import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import type { MovementRow } from "@/lib/partTakeOut";

export function useSparePartMovements(partId: string | undefined) {
  return useQuery({
    queryKey: ["spare_part_movements", partId],
    enabled: !!partId,
    queryFn: async (): Promise<MovementRow[]> => {
      const { data, error } = await supabase
        .from("spare_part_movements")
        .select("id, type, reason, bin_id, note, performed_by, performed_at, backfilled")
        .eq("spare_part_id", partId!)
        .order("performed_at", { ascending: false });
      if (error) throw error;
      return (data || []) as MovementRow[];
    },
  });
}
